import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "@/views/homePage/homePage.vue";
import NotFoundPage from "@/views/notFoundPage/notFoundPage.vue";
import DownloadPage from "@/views/downloadPage/downloadPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/download",
    name: "download",
    component: DownloadPage,
  },
  {
    path: "*",
    component: NotFoundPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

export default router;
